module.exports = __webpack_public_path__ + "static/media/stick2.cc72a385.png";